// Default State
const state = {
	needsMinicartRefresh: 'false',
}

// Module Getters
const getters = {
	getMinicartRefreshStatus: state => {
		return state.needsMinicartRefresh;
	},
}

// Module Actions
const actions = {

}

// Module Mutations
const mutations = {
	updateMinicartRefreshStatus(state, payload) {
		state.needsMinicartRefresh = payload;
	},
}

export default {
    state,
    getters,
    actions,
    mutations
}